module.exports = __webpack_public_path__ + "static/media/industryModel.e1db0341.svg";